var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 95,
    viewBox: "0 0 152 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iaf_logo_svg",
    transform: "translate(-23.41 -30.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12035",
    "data-name": "Path 12035",
    d: "M99.409,125.48c-18.249,0-35.691-3.747-49.111-10.552C33.21,106.264,23.41,92.8,23.41,77.979S33.21,49.694,50.3,41.032C63.717,34.227,81.16,30.48,99.409,30.48s35.691,3.747,49.114,10.552C165.607,49.7,175.41,63.165,175.41,77.979s-9.8,28.285-26.888,36.949C135.1,121.733,117.66,125.48,99.409,125.48Zm-39.366-47.5C63.3,81.836,77.108,89.2,99.406,89.2s36.106-7.368,39.366-11.225c-3.257-3.857-17.068-11.225-39.366-11.225S63.3,74.122,60.043,77.979Z",
    transform: "translate(0 0)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12036",
    "data-name": "Path 12036",
    d: "M104.807,128.695c-17.913,0-35-3.664-48.122-10.316C40.361,110.1,31,97.347,31,83.387S40.361,56.673,56.685,48.4C69.8,41.744,86.894,38.08,104.807,38.08s35,3.664,48.122,10.316c16.324,8.277,25.685,21.033,25.685,34.992s-9.361,26.714-25.685,34.992C139.81,125.031,122.721,128.695,104.807,128.695ZM62.839,83.385C64.048,86.806,78.255,96.8,104.807,96.8s40.759-10,41.969-13.416c-1.212-3.421-15.42-13.416-41.969-13.416S64.051,79.963,62.839,83.385Z",
    transform: "translate(-5.399 -5.406)",
    fill: "#007aba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426",
    transform: "translate(41.55 48.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12037",
    "data-name": "Path 12037",
    d: "M224.32,169.67h-7.587a40.257,40.257,0,0,0-.652,7.079h7.847A68.11,68.11,0,0,1,224.32,169.67Z",
    transform: "translate(-178.729 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12038",
    "data-name": "Path 12038",
    d: "M288.13,94.22v6.21h3.415C290.544,96.686,289.325,94.477,288.13,94.22Z",
    transform: "translate(-230.044 -94.22)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12039",
    "data-name": "Path 12039",
    d: "M288.13,255.189h3.54a62.033,62.033,0,0,0,1.314-7.079H288.13Z",
    transform: "translate(-230.047 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12040",
    "data-name": "Path 12040",
    d: "M288.13,176.749H293.9q-.009-3.729-.193-7.079H288.13Z",
    transform: "translate(-230.048 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12041",
    "data-name": "Path 12041",
    d: "M288.13,229.049h4.911c.274-2.162.494-4.53.641-7.079H288.13Z",
    transform: "translate(-230.048 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12042",
    "data-name": "Path 12042",
    d: "M288.13,202.889h5.578c.118-2.232.188-4.593.193-7.079H288.13Z",
    transform: "translate(-230.048 -166.48)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12043",
    "data-name": "Path 12043",
    d: "M288.13,124.446h4.853a62.094,62.094,0,0,0-1.314-7.076h-3.54Z",
    transform: "translate(-230.047 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12044",
    "data-name": "Path 12044",
    d: "M338.068,102.408h4.868A60.369,60.369,0,0,0,325.37,97a41.236,41.236,0,0,1,12.695,5.408Z",
    transform: "translate(-256.604 -96.197)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12045",
    "data-name": "Path 12045",
    d: "M294.907,100.836h3.41c-1.741-3.26-3.857-5.419-6.167-6.046C293.189,95.792,294.125,97.894,294.907,100.836Z",
    transform: "translate(-232.913 -94.625)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12046",
    "data-name": "Path 12046",
    d: "M376.856,117.37h-5.1a33,33,0,0,1,7.593,7.076h7.3A39.332,39.332,0,0,0,376.856,117.37Z",
    transform: "translate(-289.645 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12047",
    "data-name": "Path 12047",
    d: "M328.219,102.479h3.82a41.448,41.448,0,0,0-13.9-5.379A30,30,0,0,1,328.219,102.479Z",
    transform: "translate(-251.444 -96.269)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12048",
    "data-name": "Path 12048",
    d: "M302.4,101.056h4.645A18.089,18.089,0,0,0,297.19,95.1a13.8,13.8,0,0,1,5.208,5.956Z",
    transform: "translate(-236.51 -94.846)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12049",
    "data-name": "Path 12049",
    d: "M313.7,101.54h4.879a29.519,29.519,0,0,0-12.908-5.76A19.737,19.737,0,0,1,313.7,101.54Z",
    transform: "translate(-242.558 -95.33)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12050",
    "data-name": "Path 12050",
    d: "M288.13,150.589h5.552c-.147-2.552-.367-4.917-.641-7.079H288.13Z",
    transform: "translate(-230.048 -129.279)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12051",
    "data-name": "Path 12051",
    d: "M382.851,143.52H377.01a29.124,29.124,0,0,1,3.005,7.079h6.672A26.18,26.18,0,0,0,382.851,143.52Z",
    transform: "translate(-293.369 -129.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12052",
    "data-name": "Path 12052",
    d: "M422.792,176.749a19.1,19.1,0,0,0-1.472-7.079h-8.5a23.738,23.738,0,0,1,1.149,7.079h8.82Z",
    transform: "translate(-318.923 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12053",
    "data-name": "Path 12053",
    d: "M399.845,117.37H392.8a39.038,39.038,0,0,1,9.458,7.076h9.6A49.737,49.737,0,0,0,399.845,117.37Z",
    transform: "translate(-304.683 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12054",
    "data-name": "Path 12054",
    d: "M399.25,143.52a26.523,26.523,0,0,1,3.756,7.079h8.459a25.071,25.071,0,0,0-4.807-7.079Z",
    transform: "translate(-309.271 -129.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12055",
    "data-name": "Path 12055",
    d: "M340.668,100.779h6.8A92.365,92.365,0,0,0,320.75,94.71a60.889,60.889,0,0,1,19.915,6.069Z",
    transform: "translate(-253.34 -94.569)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12056",
    "data-name": "Path 12056",
    d: "M216.732,202.889h7.587a68.146,68.146,0,0,1-.393-7.079H216.08A40.313,40.313,0,0,0,216.732,202.889Z",
    transform: "translate(-178.729 -166.48)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12057",
    "data-name": "Path 12057",
    d: "M338.075,274.27a41.267,41.267,0,0,1-12.695,5.408,60.457,60.457,0,0,0,17.565-5.408h-4.868Z",
    transform: "translate(-256.611 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12058",
    "data-name": "Path 12058",
    d: "M288.13,280.473c1.2-.26,2.414-2.466,3.418-6.213H288.13Z",
    transform: "translate(-230.044 -222.28)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12059",
    "data-name": "Path 12059",
    d: "M328.219,274.27a30.086,30.086,0,0,1-10.079,5.382,41.452,41.452,0,0,0,13.9-5.382Z",
    transform: "translate(-251.444 -222.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12060",
    "data-name": "Path 12060",
    d: "M386.649,248.12h-7.3a32.893,32.893,0,0,1-7.593,7.079h5.1A39.3,39.3,0,0,0,386.649,248.12Z",
    transform: "translate(-289.645 -203.687)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12061",
    "data-name": "Path 12061",
    d: "M394.58,169.67h-6.71a29.206,29.206,0,0,1,.921,7.079h6.958a23.378,23.378,0,0,0-1.172-7.079Z",
    transform: "translate(-301.1 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12062",
    "data-name": "Path 12062",
    d: "M395.759,195.82H388.8a29.22,29.22,0,0,1-.921,7.079h6.71a23.393,23.393,0,0,0,1.172-7.079Z",
    transform: "translate(-301.107 -166.487)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12063",
    "data-name": "Path 12063",
    d: "M380.016,221.97a29.238,29.238,0,0,1-3.005,7.079h5.841a26.179,26.179,0,0,0,3.837-7.079Z",
    transform: "translate(-293.369 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12064",
    "data-name": "Path 12064",
    d: "M312.983,150.589a56.229,56.229,0,0,0-1.273-7.079h-4.9c.271,2.191.488,4.565.629,7.079Z",
    transform: "translate(-243.355 -129.279)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12065",
    "data-name": "Path 12065",
    d: "M338.253,195.82H330.4a66.6,66.6,0,0,1-.393,7.079h7.584a40.586,40.586,0,0,0,.655-7.079Z",
    transform: "translate(-259.886 -166.487)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12066",
    "data-name": "Path 12066",
    d: "M359,117.37H354.98a29.844,29.844,0,0,1,6.083,7.076h5.751a32.9,32.9,0,0,0-7.821-7.076Z",
    transform: "translate(-277.682 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12067",
    "data-name": "Path 12067",
    d: "M334.216,150.589a36.216,36.216,0,0,0-2.136-7.079H325.39a56.485,56.485,0,0,1,1.279,7.079Z",
    transform: "translate(-256.596 -129.279)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12068",
    "data-name": "Path 12068",
    d: "M314.662,202.889a67.334,67.334,0,0,0,.39-7.079h-5.771c-.006,2.448-.069,4.819-.191,7.079Z",
    transform: "translate(-244.979 -166.48)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12069",
    "data-name": "Path 12069",
    d: "M357.47,143.52h-7.16a36.976,36.976,0,0,1,2.113,7.079h8.11a28.7,28.7,0,0,0-3.066-7.079Z",
    transform: "translate(-274.351 -129.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12070",
    "data-name": "Path 12070",
    d: "M337.6,169.67H330.02a67.319,67.319,0,0,1,.393,7.079h7.85a40.557,40.557,0,0,0-.655-7.079Z",
    transform: "translate(-259.893 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12071",
    "data-name": "Path 12071",
    d: "M309.281,176.749h5.771a67.291,67.291,0,0,0-.39-7.079H309.09C309.211,171.928,309.275,174.3,309.281,176.749Z",
    transform: "translate(-244.979 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12072",
    "data-name": "Path 12072",
    d: "M334.216,221.97h-7.547a56.48,56.48,0,0,1-1.279,7.079h6.689a36.214,36.214,0,0,0,2.137-7.079Z",
    transform: "translate(-256.596 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12073",
    "data-name": "Path 12073",
    d: "M402.268,248.12a39.045,39.045,0,0,1-9.458,7.079h7.045a49.666,49.666,0,0,0,12.016-7.079Z",
    transform: "translate(-304.69 -203.687)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12074",
    "data-name": "Path 12074",
    d: "M445.448,195.82a19.491,19.491,0,0,1-1.438,7.079h11a16.13,16.13,0,0,0,1.81-7.079Z",
    transform: "translate(-341.108 -166.487)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12075",
    "data-name": "Path 12075",
    d: "M97.625,195.82H86.25a16.1,16.1,0,0,0,1.813,7.079h11a19.49,19.49,0,0,1-1.438-7.079Z",
    transform: "translate(-86.247 -166.487)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12076",
    "data-name": "Path 12076",
    d: "M97.618,176.749a19.611,19.611,0,0,1,1.438-7.079h-11a16.115,16.115,0,0,0-1.813,7.079H97.615Z",
    transform: "translate(-86.24 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12077",
    "data-name": "Path 12077",
    d: "M125.42,124.446a39,39,0,0,1,9.461-7.076h-7.045a49.736,49.736,0,0,0-12.016,7.076h9.6Z",
    transform: "translate(-107.28 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12078",
    "data-name": "Path 12078",
    d: "M313.7,274.27a19.691,19.691,0,0,1-8.029,5.76,29.519,29.519,0,0,0,12.908-5.76H313.7Z",
    transform: "translate(-242.558 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12079",
    "data-name": "Path 12079",
    d: "M346.175,248.12h-7.062a29.642,29.642,0,0,1-4.273,7.079h5.09A29.355,29.355,0,0,0,346.175,248.12Z",
    transform: "translate(-263.334 -203.687)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12080",
    "data-name": "Path 12080",
    d: "M307.034,274.27h-4.645a13.768,13.768,0,0,1-5.208,5.956A18.069,18.069,0,0,0,307.034,274.27Z",
    transform: "translate(-236.503 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12081",
    "data-name": "Path 12081",
    d: "M366.814,248.12h-5.751a29.857,29.857,0,0,1-6.083,7.079H359A32.723,32.723,0,0,0,366.814,248.12Z",
    transform: "translate(-277.682 -203.687)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12082",
    "data-name": "Path 12082",
    d: "M366.113,169.67H357.96a41.163,41.163,0,0,1,.647,7.079h8.442A28.635,28.635,0,0,0,366.113,169.67Z",
    transform: "translate(-279.798 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12083",
    "data-name": "Path 12083",
    d: "M352.423,221.97a36.976,36.976,0,0,1-2.113,7.079h7.16a28.8,28.8,0,0,0,3.063-7.079Z",
    transform: "translate(-274.351 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12084",
    "data-name": "Path 12084",
    d: "M367.049,195.82h-8.442a41.193,41.193,0,0,1-.647,7.079h8.153A28.653,28.653,0,0,0,367.049,195.82Z",
    transform: "translate(-279.798 -166.487)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12085",
    "data-name": "Path 12085",
    d: "M334.84,117.37a29.622,29.622,0,0,1,4.273,7.076h7.062a29.451,29.451,0,0,0-6.245-7.076h-5.087Z",
    transform: "translate(-263.334 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12086",
    "data-name": "Path 12086",
    d: "M302.12,117.37a62.211,62.211,0,0,1,1.293,7.076h4.839a36,36,0,0,0-2.593-7.076Z",
    transform: "translate(-240.014 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12087",
    "data-name": "Path 12087",
    d: "M292.15,280.318c2.31-.627,4.429-2.789,6.17-6.048h-3.413C294.128,277.212,293.189,279.314,292.15,280.318Z",
    transform: "translate(-232.913 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12088",
    "data-name": "Path 12088",
    d: "M227.5,229.049a55.471,55.471,0,0,1-1.276-7.079h-7.55a36.22,36.22,0,0,0,2.139,7.079H227.5Z",
    transform: "translate(-180.575 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12089",
    "data-name": "Path 12089",
    d: "M316.05,117.37a36.783,36.783,0,0,1,2.581,7.076h6.6a28.865,28.865,0,0,0-4.357-7.076Z",
    transform: "translate(-249.944 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12090",
    "data-name": "Path 12090",
    d: "M311.709,229.049a55.21,55.21,0,0,0,1.273-7.079h-5.543c-.141,2.518-.358,4.888-.629,7.079Z",
    transform: "translate(-243.355 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12091",
    "data-name": "Path 12091",
    d: "M302.12,255.189h3.54a35.709,35.709,0,0,0,2.593-7.079h-4.839A63.7,63.7,0,0,1,302.12,255.189Z",
    transform: "translate(-240.014 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12092",
    "data-name": "Path 12092",
    d: "M316.05,255.189h4.827a28.687,28.687,0,0,0,4.357-7.079h-6.6A36.813,36.813,0,0,1,316.05,255.189Z",
    transform: "translate(-249.944 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12093",
    "data-name": "Path 12093",
    d: "M250.668,195.82H244.9a67.326,67.326,0,0,0,.39,7.079h5.569C250.738,200.639,250.674,198.268,250.668,195.82Z",
    transform: "translate(-199.255 -166.487)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12094",
    "data-name": "Path 12094",
    d: "M272.281,169.67H266.7q-.182,3.348-.193,7.079h5.771Z",
    transform: "translate(-214.648 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12095",
    "data-name": "Path 12095",
    d: "M272.281,195.82H266.51q.009,3.724.193,7.079h5.578Z",
    transform: "translate(-214.648 -166.487)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12096",
    "data-name": "Path 12096",
    d: "M272.822,143.52h-4.911c-.274,2.162-.494,4.527-.641,7.079h5.552Z",
    transform: "translate(-215.189 -129.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12097",
    "data-name": "Path 12097",
    d: "M168.149,100.779a60.906,60.906,0,0,1,19.918-6.069,92.343,92.343,0,0,0-26.717,6.069Z",
    transform: "translate(-139.76 -94.569)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12098",
    "data-name": "Path 12098",
    d: "M274.543,117.37H271a62.094,62.094,0,0,0-1.314,7.076h4.853Z",
    transform: "translate(-216.912 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12099",
    "data-name": "Path 12099",
    d: "M278.078,94.22c-1.2.257-2.414,2.466-3.418,6.21h3.418Z",
    transform: "translate(-220.45 -94.22)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12100",
    "data-name": "Path 12100",
    d: "M247.972,274.27H243.33a18.079,18.079,0,0,0,9.854,5.956,13.769,13.769,0,0,1-5.208-5.956Z",
    transform: "translate(-198.143 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12101",
    "data-name": "Path 12101",
    d: "M274.543,248.12H269.69A62.156,62.156,0,0,0,271,255.2h3.54Z",
    transform: "translate(-216.912 -203.687)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12102",
    "data-name": "Path 12102",
    d: "M229.129,274.27H224.25a29.5,29.5,0,0,0,12.908,5.76A19.757,19.757,0,0,1,229.129,274.27Z",
    transform: "translate(-184.556 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12103",
    "data-name": "Path 12103",
    d: "M212.18,274.27h-3.82a41.443,41.443,0,0,0,13.9,5.382,30.059,30.059,0,0,1-10.079-5.382Z",
    transform: "translate(-173.237 -222.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12104",
    "data-name": "Path 12104",
    d: "M141.539,150.589a26.565,26.565,0,0,1,3.756-7.079h-7.408a25.131,25.131,0,0,0-4.807,7.079h8.462Z",
    transform: "translate(-119.557 -129.279)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12105",
    "data-name": "Path 12105",
    d: "M278.078,280.473V274.26H274.66C275.665,278.008,276.88,280.213,278.078,280.473Z",
    transform: "translate(-220.45 -222.28)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12106",
    "data-name": "Path 12106",
    d: "M264.53,274.27h-3.41c1.741,3.26,3.857,5.422,6.17,6.048-1.039-1-1.978-3.107-2.757-6.048Z",
    transform: "translate(-210.81 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12107",
    "data-name": "Path 12107",
    d: "M403.006,221.97a26.523,26.523,0,0,1-3.756,7.079h7.408a25.131,25.131,0,0,0,4.807-7.079Z",
    transform: "translate(-309.271 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12108",
    "data-name": "Path 12108",
    d: "M104.341,150.589a25.312,25.312,0,0,1,4.686-7.079H99.306a25.527,25.527,0,0,0-5.916,7.079Z",
    transform: "translate(-91.326 -129.279)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12109",
    "data-name": "Path 12109",
    d: "M427.093,143.52a25.324,25.324,0,0,1,4.683,7.079h10.948a25.569,25.569,0,0,0-5.916-7.079H427.09Z",
    transform: "translate(-329.073 -129.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12110",
    "data-name": "Path 12110",
    d: "M444.01,169.67a19.539,19.539,0,0,1,1.438,7.079h11.375a16.131,16.131,0,0,0-1.81-7.079Z",
    transform: "translate(-341.108 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12111",
    "data-name": "Path 12111",
    d: "M431.783,221.97a25.323,25.323,0,0,1-4.683,7.079h9.718a25.565,25.565,0,0,0,5.913-7.079Z",
    transform: "translate(-329.08 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12112",
    "data-name": "Path 12112",
    d: "M422.8,195.82h-8.82a23.846,23.846,0,0,1-1.149,7.079h8.5a19.161,19.161,0,0,0,1.472-7.079Z",
    transform: "translate(-318.93 -166.487)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12113",
    "data-name": "Path 12113",
    d: "M109.017,229.049a25.271,25.271,0,0,1-4.686-7.079H93.38a25.527,25.527,0,0,0,5.916,7.079Z",
    transform: "translate(-91.319 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12114",
    "data-name": "Path 12114",
    d: "M340.675,274.27a60.891,60.891,0,0,1-19.915,6.072,92.246,92.246,0,0,0,26.717-6.072h-6.8Z",
    transform: "translate(-253.347 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12115",
    "data-name": "Path 12115",
    d: "M193.288,274.27H188.42a60.368,60.368,0,0,0,17.565,5.408A41.283,41.283,0,0,1,193.288,274.27Z",
    transform: "translate(-159.036 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12116",
    "data-name": "Path 12116",
    d: "M127.826,255.189h7.045a38.97,38.97,0,0,1-9.458-7.079h-9.6A49.646,49.646,0,0,0,127.826,255.189Z",
    transform: "translate(-107.273 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12117",
    "data-name": "Path 12117",
    d: "M137.259,202.889a23.752,23.752,0,0,1-1.149-7.079h-8.82a19.158,19.158,0,0,0,1.47,7.079Z",
    transform: "translate(-115.438 -166.48)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12118",
    "data-name": "Path 12118",
    d: "M145.288,229.049a26.522,26.522,0,0,1-3.756-7.079H133.07a25.192,25.192,0,0,0,4.807,7.079h7.408Z",
    transform: "translate(-119.55 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12119",
    "data-name": "Path 12119",
    d: "M127.28,176.749h8.82a23.737,23.737,0,0,1,1.149-7.079h-8.5A19.077,19.077,0,0,0,127.28,176.749Z",
    transform: "translate(-115.431 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12120",
    "data-name": "Path 12120",
    d: "M168.149,274.27h-6.8a92.268,92.268,0,0,0,26.717,6.072,60.891,60.891,0,0,1-19.915-6.072Z",
    transform: "translate(-139.76 -222.288)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12121",
    "data-name": "Path 12121",
    d: "M272.822,221.97H267.27c.147,2.552.364,4.917.641,7.079h4.911Z",
    transform: "translate(-215.189 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12122",
    "data-name": "Path 12122",
    d: "M186.488,255.189H190.5a29.8,29.8,0,0,1-6.083-7.079H178.67A32.783,32.783,0,0,0,186.488,255.189Z",
    transform: "translate(-152.084 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12123",
    "data-name": "Path 12123",
    d: "M199.143,229.049a36.771,36.771,0,0,1-2.113-7.079h-8.11a28.7,28.7,0,0,0,3.063,7.079h7.163Z",
    transform: "translate(-159.384 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12124",
    "data-name": "Path 12124",
    d: "M185.2,176.749h8.445a40.872,40.872,0,0,1,.65-7.079h-8.156a28.751,28.751,0,0,0-.935,7.079Z",
    transform: "translate(-156.733 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12125",
    "data-name": "Path 12125",
    d: "M186.128,202.889h8.156a40.9,40.9,0,0,1-.65-7.079H185.19a28.786,28.786,0,0,0,.935,7.079Z",
    transform: "translate(-156.726 -166.48)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12126",
    "data-name": "Path 12126",
    d: "M211.872,255.189a29.485,29.485,0,0,1-4.27-7.079H200.54a29.409,29.409,0,0,0,6.245,7.079Z",
    transform: "translate(-167.663 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12127",
    "data-name": "Path 12127",
    d: "M235.957,255.189a36.931,36.931,0,0,1-2.584-7.079h-6.6a28.829,28.829,0,0,0,4.357,7.079Z",
    transform: "translate(-186.346 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12128",
    "data-name": "Path 12128",
    d: "M197.03,150.589a37.037,37.037,0,0,1,2.113-7.079h-7.16a28.7,28.7,0,0,0-3.063,7.079Z",
    transform: "translate(-159.384 -129.279)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12129",
    "data-name": "Path 12129",
    d: "M235.957,117.37h-4.83a28.865,28.865,0,0,0-4.357,7.076h6.6A36.972,36.972,0,0,1,235.957,117.37Z",
    transform: "translate(-186.346 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12130",
    "data-name": "Path 12130",
    d: "M220.809,143.52a36.217,36.217,0,0,0-2.139,7.079h7.55a56.6,56.6,0,0,1,1.276-7.079h-6.689Z",
    transform: "translate(-180.575 -129.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12131",
    "data-name": "Path 12131",
    d: "M257.405,255.189a62.224,62.224,0,0,1-1.3-7.079H251.27a35.959,35.959,0,0,0,2.6,7.079Z",
    transform: "translate(-203.793 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12132",
    "data-name": "Path 12132",
    d: "M245.29,169.67a67.247,67.247,0,0,0-.39,7.079h5.768c.006-2.451.069-4.819.191-7.079Z",
    transform: "translate(-199.255 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12133",
    "data-name": "Path 12133",
    d: "M200.54,124.446H207.6a29.615,29.615,0,0,1,4.27-7.076h-5.087A29.452,29.452,0,0,0,200.54,124.446Z",
    transform: "translate(-167.663 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12134",
    "data-name": "Path 12134",
    d: "M178.663,124.446h5.751a29.845,29.845,0,0,1,6.083-7.076h-4.016a32.848,32.848,0,0,0-7.821,7.076Z",
    transform: "translate(-152.077 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12135",
    "data-name": "Path 12135",
    d: "M243.313,101.056h4.642a13.822,13.822,0,0,1,5.208-5.956,18.1,18.1,0,0,0-9.854,5.956Z",
    transform: "translate(-198.129 -94.846)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12136",
    "data-name": "Path 12136",
    d: "M170.779,150.589a29.294,29.294,0,0,1,3.008-7.079h-5.841a26.26,26.26,0,0,0-3.837,7.079Z",
    transform: "translate(-141.711 -129.279)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12137",
    "data-name": "Path 12137",
    d: "M159.47,176.749h6.958a29.2,29.2,0,0,1,.921-7.079h-6.707A23.364,23.364,0,0,0,159.47,176.749Z",
    transform: "translate(-138.404 -147.887)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12138",
    "data-name": "Path 12138",
    d: "M151.31,124.446h7.3a32.926,32.926,0,0,1,7.59-7.076h-5.1A39.421,39.421,0,0,0,151.31,124.446Z",
    transform: "translate(-132.596 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12139",
    "data-name": "Path 12139",
    d: "M160.642,202.889h6.707a29.08,29.08,0,0,1-.921-7.079H159.47A23.3,23.3,0,0,0,160.642,202.889Z",
    transform: "translate(-138.404 -166.48)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12140",
    "data-name": "Path 12140",
    d: "M246.45,221.97a55.718,55.718,0,0,0,1.273,7.079h4.9c-.274-2.191-.488-4.562-.632-7.079Z",
    transform: "translate(-200.36 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12141",
    "data-name": "Path 12141",
    d: "M193.3,102.408A41.336,41.336,0,0,1,205.992,97a60.234,60.234,0,0,0-17.562,5.408Z",
    transform: "translate(-159.043 -96.197)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12142",
    "data-name": "Path 12142",
    d: "M173.788,229.049a29.245,29.245,0,0,1-3.008-7.079H164.11a26.259,26.259,0,0,0,3.837,7.079Z",
    transform: "translate(-141.711 -185.087)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12143",
    "data-name": "Path 12143",
    d: "M267.29,94.79c-2.313.626-4.429,2.786-6.17,6.046h3.41c.78-2.942,1.721-5.044,2.757-6.046Z",
    transform: "translate(-210.81 -94.625)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12144",
    "data-name": "Path 12144",
    d: "M257.405,117.37h-3.54a36,36,0,0,0-2.6,7.076h4.839A62.805,62.805,0,0,1,257.405,117.37Z",
    transform: "translate(-203.793 -110.686)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12145",
    "data-name": "Path 12145",
    d: "M247.723,143.52a55.717,55.717,0,0,0-1.273,7.079h5.54c.144-2.515.358-4.888.632-7.079Z",
    transform: "translate(-200.36 -129.287)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12146",
    "data-name": "Path 12146",
    d: "M161.1,255.189h5.1a32.948,32.948,0,0,1-7.593-7.079h-7.3A39.3,39.3,0,0,0,161.1,255.189Z",
    transform: "translate(-132.596 -203.68)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12147",
    "data-name": "Path 12147",
    d: "M229.129,101.54a19.737,19.737,0,0,1,8.029-5.76,29.535,29.535,0,0,0-12.908,5.76Z",
    transform: "translate(-184.556 -95.33)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12148",
    "data-name": "Path 12148",
    d: "M212.18,102.479A30,30,0,0,1,222.259,97.1a41.509,41.509,0,0,0-13.9,5.379Z",
    transform: "translate(-173.237 -96.269)",
    fill: "#004896"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12149",
    "data-name": "Path 12149",
    d: "M141.885,152.116c-32.216,0-58.425-13.425-58.425-29.928S109.668,92.26,141.885,92.26s58.428,13.425,58.428,29.928S174.1,152.116,141.885,152.116Zm0-58.724c-31.595,0-57.3,12.917-57.3,28.8s25.7,28.8,57.3,28.8,57.3-12.917,57.3-28.8-25.7-28.8-57.3-28.8Z",
    transform: "translate(-42.713 -43.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12150",
    "data-name": "Path 12150",
    d: "M201.034,121.838H190.06a19.547,19.547,0,0,0-1.433-7.079h10.589a.237.237,0,0,0,0-.473H188.431a25.372,25.372,0,0,0-4.667-7.079h9.13a.237.237,0,0,0,0-.473h-9.57a38.917,38.917,0,0,0-9.426-7.076h5.9a.237.237,0,0,0,0-.473h-6.776c-8.028-4.192-18.295-6.713-29.47-6.713s-21.44,2.52-29.468,6.713h-7.5a.237.237,0,0,0,0,.473H113.2a38.879,38.879,0,0,0-9.429,7.076h-10.3a.237.237,0,0,0,0,.473h9.867a25.278,25.278,0,0,0-4.67,7.079H87.353a.237.237,0,0,0,0,.473H98.466a19.535,19.535,0,0,0-1.433,7.079H85.7a.235.235,0,1,0,0,.471H97.033a19.668,19.668,0,0,0,1.433,7.079H87.12a.237.237,0,0,0,0,.473H98.664a25.278,25.278,0,0,0,4.67,7.079H93.269a.236.236,0,0,0-.236.237.233.233,0,0,0,.236.234h10.5a38.926,38.926,0,0,0,9.426,7.079h-7.922a.237.237,0,0,0,0,.473h8.8c8.031,4.192,18.295,6.715,29.47,6.715s21.442-2.52,29.47-6.715h8.183a.237.237,0,0,0,0-.473h-7.3a38.741,38.741,0,0,0,9.426-7.079h10.128a.237.237,0,0,0,.236-.234.239.239,0,0,0-.236-.237h-9.685a25.33,25.33,0,0,0,4.667-7.079H199.3a.237.237,0,0,0,0-.473H188.641a19.608,19.608,0,0,0,1.433-7.079h10.974a.237.237,0,0,0,.236-.237.233.233,0,0,0-.236-.234Zm-11.441,0H180.8a23.9,23.9,0,0,0-1.145-7.079h8.471a19.193,19.193,0,0,1,1.467,7.079ZM151.079,99.185h-3.4c-.777-2.942-1.712-5.044-2.748-6.046C147.235,93.766,149.347,95.926,151.079,99.185Zm-4.7-5.953a18.017,18.017,0,0,1,9.818,5.956h-4.63a13.77,13.77,0,0,0-5.191-5.956Zm4.946,6.427a35.9,35.9,0,0,1,2.584,7.076h-4.823a63.711,63.711,0,0,0-1.289-7.076Zm-8.022,22.649v7.079h-5.556c-.121-2.232-.19-4.593-.193-7.079h5.752Zm-5.749-.471q.009-3.729.193-7.079h5.556v7.079h-5.752Zm6.218.471h5.752q-.009,3.724-.193,7.079h-5.559Zm0-.471v-7.079h5.559c.118,2.232.187,4.593.193,7.079h-5.752Zm0-7.553v-7.079h4.894c.273,2.162.492,4.527.639,7.079Zm-.469,0h-5.533c.147-2.552.365-4.917.639-7.079h4.894Zm-6,0h-5.522a55.88,55.88,0,0,1,1.269-7.079h4.883C137.662,109.4,137.449,111.77,137.305,114.285Zm-.029.473c-.121,2.258-.184,4.628-.19,7.079h-5.749a67.516,67.516,0,0,1,.388-7.079Zm-.19,7.55c.006,2.448.069,4.819.19,7.079h-5.551a67.56,67.56,0,0,1-.388-7.079Zm.219,7.55c.144,2.518.357,4.888.63,7.079h-4.883a55.881,55.881,0,0,1-1.269-7.079Zm.469,0h5.533v7.079h-4.894C138.14,134.775,137.921,132.407,137.774,129.858Zm6,0h5.533c-.147,2.552-.365,4.917-.639,7.079h-4.894Zm6,0H155.3a56.4,56.4,0,0,1-1.269,7.079h-4.883C149.422,134.746,149.638,132.376,149.779,129.858Zm.029-.473c.121-2.261.184-4.631.19-7.079h5.752a67.559,67.559,0,0,1-.388,7.079Zm.19-7.547c-.006-2.451-.069-4.819-.19-7.079h5.553a67.473,67.473,0,0,1,.388,7.079Zm-.219-7.553c-.141-2.515-.357-4.888-.627-7.079h4.883a55.376,55.376,0,0,1,1.269,7.079Zm-1.165-7.55h-4.837V99.659H147.3A62.286,62.286,0,0,1,148.613,106.735Zm-5.306,0h-4.834a61.7,61.7,0,0,1,1.306-7.076h3.528Zm-5.315,0H133.17a36.076,36.076,0,0,1,2.587-7.076h3.528a62.359,62.359,0,0,0-1.292,7.076ZM136,99.185c1.735-3.26,3.844-5.419,6.149-6.046-1.036,1-1.971,3.1-2.748,6.046h-3.4Zm-.492,0h-4.627a18.024,18.024,0,0,1,9.821-5.956,13.771,13.771,0,0,0-5.191,5.956Zm-.236.473a37.052,37.052,0,0,0-2.575,7.076h-6.581a28.882,28.882,0,0,1,4.342-7.076Zm-2.69,7.55a55.644,55.644,0,0,0-1.272,7.079H123.79a36.309,36.309,0,0,1,2.132-7.079h6.667Zm-1.329,7.55a68.332,68.332,0,0,0-.391,7.079h-7.821a40.416,40.416,0,0,1,.65-7.079Zm-.391,7.55a68.377,68.377,0,0,0,.391,7.079H123.7a40.44,40.44,0,0,1-.65-7.079Zm.449,7.55a56.673,56.673,0,0,0,1.272,7.079h-6.667a36.31,36.31,0,0,1-2.132-7.079h7.524Zm1.39,7.55a37.085,37.085,0,0,0,2.575,7.079h-4.814a28.791,28.791,0,0,1-4.342-7.079Zm2.808,7.55a13.789,13.789,0,0,0,5.191,5.956,18.007,18.007,0,0,1-9.821-5.956h4.627Zm.492,0h3.4c.777,2.942,1.712,5.044,2.748,6.049-2.3-.627-4.414-2.789-6.149-6.049Zm-.247-.473a35.971,35.971,0,0,1-2.587-7.079h4.823a63.188,63.188,0,0,0,1.292,7.079Zm2.713-7.076h4.837v7.079H139.78A62.219,62.219,0,0,1,138.471,137.408Zm5.306,0h4.837a62.346,62.346,0,0,1-1.309,7.079h-3.528Zm5.315,0h4.823a36.041,36.041,0,0,1-2.584,7.079H147.8A62.465,62.465,0,0,0,149.091,137.408Zm1.991,7.55c-1.735,3.26-3.847,5.422-6.149,6.049,1.036-1,1.968-3.107,2.748-6.049Zm.489,0h4.63a18,18,0,0,1-9.821,5.956A13.753,13.753,0,0,0,151.571,144.958Zm.239-.473a36.821,36.821,0,0,0,2.572-7.079h6.581a28.845,28.845,0,0,1-4.342,7.079Zm2.688-7.547a56.662,56.662,0,0,0,1.275-7.079h7.522a36.306,36.306,0,0,1-2.129,7.079Zm1.332-7.553a67.584,67.584,0,0,0,.391-7.079h7.824a40.718,40.718,0,0,1-.653,7.079h-7.559Zm.388-7.547a66.767,66.767,0,0,0-.391-7.079h7.559a40.665,40.665,0,0,1,.653,7.079h-7.824Zm-.446-7.553a56.759,56.759,0,0,0-1.275-7.079h6.667a36.307,36.307,0,0,1,2.129,7.079Zm-1.39-7.55a36.861,36.861,0,0,0-2.572-7.076h4.811a28.793,28.793,0,0,1,4.342,7.076Zm2.834-7.076h5.07a29.42,29.42,0,0,1,6.224,7.076h-7.038a29.642,29.642,0,0,0-4.259-7.076Zm-.391-.473a19.654,19.654,0,0,0-8-5.76,29.373,29.373,0,0,1,12.865,5.76Zm-9.642,0h-3.4v-6.21C144.973,93.232,146.185,95.441,147.183,99.185Zm-7.283,0c1-3.745,2.216-5.953,3.407-6.21v6.21Zm-9.642,0H125.4a29.373,29.373,0,0,1,12.865-5.76A19.692,19.692,0,0,0,130.258,99.185Zm-.391.473a29.54,29.54,0,0,0-4.256,7.076h-7.038a29.42,29.42,0,0,1,6.224-7.076h5.07Zm-4.448,7.55a36.863,36.863,0,0,0-2.106,7.079H115.23a28.745,28.745,0,0,1,3.053-7.079Zm-2.2,7.55a41,41,0,0,0-.647,7.079h-8.416a28.86,28.86,0,0,1,.932-7.079h8.129Zm-.647,7.55a41.031,41.031,0,0,0,.647,7.079h-8.129a28.878,28.878,0,0,1-.932-7.079h8.416Zm.739,7.55a37.069,37.069,0,0,0,2.106,7.079H118.28a28.854,28.854,0,0,1-3.053-7.079h8.083Zm2.3,7.55a29.654,29.654,0,0,0,4.256,7.079H124.8a29.325,29.325,0,0,1-6.224-7.079Zm4.647,7.55a19.646,19.646,0,0,0,8,5.76,29.387,29.387,0,0,1-12.865-5.76Zm9.642,0h3.407v6.213C142.116,150.911,140.9,148.705,139.9,144.958Zm7.283,0c-1,3.747-2.213,5.953-3.407,6.213v-6.213Zm9.642,0h4.866a29.34,29.34,0,0,1-12.865,5.76,19.673,19.673,0,0,0,8-5.76Zm.391-.473a29.6,29.6,0,0,0,4.259-7.079h7.038a29.379,29.379,0,0,1-6.224,7.079Zm4.451-7.547a37.071,37.071,0,0,0,2.106-7.079h8.083a28.854,28.854,0,0,1-3.053,7.079h-7.136Zm2.2-7.553a41.323,41.323,0,0,0,.645-7.079h8.414a28.74,28.74,0,0,1-.932,7.079Zm.645-7.547a41.3,41.3,0,0,0-.645-7.079h8.126a28.7,28.7,0,0,1,.932,7.079Zm-.737-7.553a37.134,37.134,0,0,0-2.106-7.079H168.8a28.862,28.862,0,0,1,3.056,7.079h-8.083Zm5.576-7.076h5.821A26.208,26.208,0,0,1,179,114.288h-6.65A29.339,29.339,0,0,0,169.351,107.209Zm-.276-.473a29.948,29.948,0,0,0-6.063-7.076h4a32.832,32.832,0,0,1,7.795,7.076h-5.732Zm-6.618-7.55a29.867,29.867,0,0,0-10.045-5.379,41.287,41.287,0,0,1,13.852,5.379Zm-37.826,0h-3.807a41.226,41.226,0,0,1,13.852-5.379A29.9,29.9,0,0,0,124.63,99.185Zm-.555.473a29.817,29.817,0,0,0-6.063,7.076H112.28a32.776,32.776,0,0,1,7.795-7.076h4Zm-6.339,7.55a29.3,29.3,0,0,0-3,7.079h-6.647a26.287,26.287,0,0,1,3.824-7.079h5.821Zm-3.128,7.55a29.153,29.153,0,0,0-.918,7.079h-6.935a23.361,23.361,0,0,1,1.168-7.079Zm-.921,7.55a29.313,29.313,0,0,0,.918,7.079h-6.684a23.465,23.465,0,0,1-1.168-7.079Zm1.05,7.55a29.3,29.3,0,0,0,3,7.079h-5.821a26.287,26.287,0,0,1-3.824-7.079Zm3.274,7.55a29.831,29.831,0,0,0,6.063,7.079h-4a32.651,32.651,0,0,1-7.792-7.079Zm6.618,7.55a29.925,29.925,0,0,0,10.045,5.382,41.245,41.245,0,0,1-13.855-5.382h3.807Zm37.826,0h3.807a41.23,41.23,0,0,1-13.852,5.382,29.926,29.926,0,0,0,10.045-5.382Zm.555-.473a29.774,29.774,0,0,0,6.063-7.079h5.732a32.823,32.823,0,0,1-7.792,7.079Zm6.339-7.547a29.177,29.177,0,0,0,3-7.079H179a26.207,26.207,0,0,1-3.824,7.079Zm3.128-7.553a29.313,29.313,0,0,0,.918-7.079h6.935a23.466,23.466,0,0,1-1.168,7.079h-6.687Zm.918-7.547a29.3,29.3,0,0,0-.918-7.079h6.687a23.436,23.436,0,0,1,1.168,7.079H173.4Zm14.525-7.553h-8.431a26.6,26.6,0,0,0-3.743-7.079h7.383A25.136,25.136,0,0,1,187.922,114.285Zm-5.243-7.55h-7.271a32.816,32.816,0,0,0-7.568-7.076h5.079A39.311,39.311,0,0,1,182.679,106.735ZM172,99.185h-4.851a41.124,41.124,0,0,0-12.652-5.408A59.932,59.932,0,0,1,172,99.185Zm-39.406-5.4a41.054,41.054,0,0,0-12.652,5.408h-4.851A59.972,59.972,0,0,1,132.592,93.781Zm-18.427,5.878h5.081a32.86,32.86,0,0,0-7.565,7.076h-7.274A39.294,39.294,0,0,1,114.165,99.659Zm-10.212,7.55h7.383a26.552,26.552,0,0,0-3.744,7.079H99.159a25.2,25.2,0,0,1,4.791-7.079Zm-5,7.55h8.471a23.81,23.81,0,0,0-1.145,7.079h-8.79A19.213,19.213,0,0,1,98.958,114.758Zm-1.465,7.55h8.79a23.825,23.825,0,0,0,1.145,7.079H98.958A19.155,19.155,0,0,1,97.493,122.308Zm1.669,7.55H107.6a26.552,26.552,0,0,0,3.744,7.079h-7.383a25.135,25.135,0,0,1-4.791-7.079Zm5.246,7.55h7.271a32.944,32.944,0,0,0,7.568,7.079h-5.081A39.176,39.176,0,0,1,104.408,137.408Zm10.678,7.55h4.851a41.042,41.042,0,0,0,12.655,5.408A60.106,60.106,0,0,1,115.086,144.958Zm39.409,5.408a41.025,41.025,0,0,0,12.652-5.408H172a60.019,60.019,0,0,1-17.506,5.408Zm18.427-5.881H167.84a32.881,32.881,0,0,0,7.568-7.079h7.271a39.176,39.176,0,0,1-9.757,7.079Zm10.212-7.547H175.75a26.552,26.552,0,0,0,3.744-7.079h8.431A25.074,25.074,0,0,1,183.134,136.937Zm4.992-7.553h-8.471a23.826,23.826,0,0,0,1.145-7.079h8.79a19.159,19.159,0,0,1-1.467,7.079Z",
    transform: "translate(-44.135 -44.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3429",
    "data-name": "Group 3429",
    transform: "translate(31.892 37.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3427",
    "data-name": "Group 3427",
    transform: "translate(0 47.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12151",
    "data-name": "Path 12151",
    d: "M54.528,222.787l-1.487.13-.251-1.36,7.14-.407.436,1.008-5.194,4.917-.817-1.114,1.12-.982Zm1.412-.136.6,1.386,1.819-1.608-2.417.222Z",
    transform: "translate(-52.79 -221.15)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12152",
    "data-name": "Path 12152",
    d: "M79.893,246.276l-1.3.009a1.629,1.629,0,0,0-.448-1.472c-.69-.794-1.882-.3-2.673.39s-1.446,1.8-.754,2.6a1.627,1.627,0,0,0,1.4.647l-.188,1.282a2.759,2.759,0,0,1-2.209-1.06c-1.169-1.345-.491-3.329.855-4.5s3.441-1.527,4.573-.225a2.755,2.755,0,0,1,.745,2.336Z",
    transform: "translate(-67.253 -236.774)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12153",
    "data-name": "Path 12153",
    d: "M101.914,264.689l-1.265.283a1.63,1.63,0,0,0-.751-1.342c-.843-.629-1.9.107-2.532.95s-1.028,2.07-.188,2.7a1.624,1.624,0,0,0,1.5.335l.089,1.293a2.752,2.752,0,0,1-2.385-.566c-1.429-1.065-1.187-3.15-.121-4.579s3.04-2.223,4.423-1.192a2.756,2.756,0,0,1,1.224,2.125Z",
    transform: "translate(-83.09 -250.277)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12154",
    "data-name": "Path 12154",
    d: "M118.609,280.907l-1.189-.632,3.21-6.054,1.553.826a2.41,2.41,0,0,1,1.2,3.182,2.171,2.171,0,0,1-2.041,1.117l.586,2.769-1.331.043-.583-3.167-.3-.162-1.1,2.079Zm2.1-3.078a1.064,1.064,0,0,0,1.464-.245c.268-.505.061-.99-.618-1.348l-.364-.193-.846,1.594Z",
    transform: "translate(-98.761 -258.898)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12155",
    "data-name": "Path 12155",
    d: "M147.608,292.479l-.5,1.253-3.482-1.38,2.526-6.372,3.378,1.34-.5,1.253-2.125-.843-.456,1.146,1.8.716-.5,1.253-1.8-.716-.58,1.467Z",
    transform: "translate(-117.483 -267.263)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12156",
    "data-name": "Path 12156",
    d: "M174.4,299.071a3.307,3.307,0,0,1-3.981,2.532l-2.073-.6,1.911-6.583,2.073.6a3.264,3.264,0,0,1,2.073,4.051Zm-4.386,1.013.78.225a1.957,1.957,0,0,0,2.289-1.62,1.882,1.882,0,0,0-1.132-2.373l-.78-.225Z",
    transform: "translate(-135.088 -273.266)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12157",
    "data-name": "Path 12157",
    d: "M200.29,309.06l-1.34-.286,1.426-6.7,1.34.286Z",
    transform: "translate(-156.877 -278.707)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12158",
    "data-name": "Path 12158",
    d: "M219.455,312.213l.82-5.445-1.695-.254.2-1.334,4.723.71-.2,1.334-1.695-.254-.82,5.445-1.334-.2Z",
    transform: "translate(-170.859 -280.92)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12159",
    "data-name": "Path 12159",
    d: "M241.743,314.685l-.586,1.371-1.317-.422,3.017-6.484,1.094.092,1.879,6.9-1.368.193-.335-1.449-2.379-.2Zm.549-1.3,1.5.127-.557-2.365-.947,2.235Z",
    transform: "translate(-186.001 -283.743)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12160",
    "data-name": "Path 12160",
    d: "M270.262,317.354l.13-5.506-1.712-.04.032-1.348,4.772.113-.032,1.348-1.712-.04-.13,5.506Z",
    transform: "translate(-206.538 -284.675)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12161",
    "data-name": "Path 12161",
    d: "M298,317.381l-1.371.04-.2-6.851,1.371-.04Z",
    transform: "translate(-226.296 -284.725)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12162",
    "data-name": "Path 12162",
    d: "M319.734,311.9c.159,1.8-.765,3.681-2.561,3.84s-3.037-1.53-3.2-3.329.762-3.681,2.561-3.84S319.575,310.1,319.734,311.9Zm-2.679,2.52c1.06-.1,1.415-1.262,1.314-2.4s-.655-2.223-1.715-2.131-1.415,1.259-1.314,2.4S315.995,314.516,317.054,314.424Z",
    transform: "translate(-238.786 -283.327)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12163",
    "data-name": "Path 12163",
    d: "M345.728,306.735l.759,4.461-1.328.225-1.149-6.756,1.328-.225,3.372,4.016L347.951,304l1.328-.225,1.149,6.756-1.328.225Z",
    transform: "translate(-260.189 -279.917)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12164",
    "data-name": "Path 12164",
    d: "M393.134,300.728l-2.044-6.542,3.248-1.016.4,1.288-1.963.612.4,1.288,1.854-.58.4,1.288-1.854.58.837,2.682-1.288.4Z",
    transform: "translate(-293.713 -272.377)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12165",
    "data-name": "Path 12165",
    d: "M421.081,287.083c.7,1.66.407,3.736-1.253,4.44s-3.361-.523-4.068-2.183-.407-3.736,1.253-4.44S420.374,285.423,421.081,287.083Zm-1.77,3.222c.979-.416.956-1.634.511-2.685s-1.308-1.914-2.287-1.5-.956,1.634-.511,2.685S418.335,290.721,419.311,290.3Z",
    transform: "translate(-311.032 -266.35)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12166",
    "data-name": "Path 12166",
    d: "M444.658,279.136l-1.161.687-3.488-5.9,1.516-.9a2.407,2.407,0,0,1,3.337.641,2.168,2.168,0,0,1-.113,2.324l2.668.944-.655,1.158-3.005-1.155-.294.173,1.2,2.027Zm-1.527-3.4a1.063,1.063,0,0,0,.554-1.374c-.292-.491-.814-.569-1.472-.179l-.355.211.918,1.553Z",
    transform: "translate(-328.606 -257.768)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12167",
    "data-name": "Path 12167",
    d: "M468.968,253.973a2.694,2.694,0,1,1-4.039,3.5l-2.619-3.02,1.019-.883,2.29,2.642c.814.941,1.68,1.432,2.431.78s.387-1.576-.427-2.518l-2.289-2.642,1.019-.883,2.619,3.02Z",
    transform: "translate(-344.467 -242.346)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12168",
    "data-name": "Path 12168",
    d: "M487.708,230.36l3.678,3-.872,1.045-5.084-4.663.647-1.051,4.92,1.423-3.482-3.756.647-1.051,6.45,2.445-.543,1.25-4.336-1.934,3.219,3.528-.647,1.051-4.6-1.291Z",
    transform: "translate(-360.912 -224.109)",
    fill: "#004896"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3428",
    "data-name": "Group 3428",
    transform: "translate(9.952 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12169",
    "data-name": "Path 12169",
    d: "M92.769,118.727l-1.039.892-4.469-5.2,1.039-.892Z",
    transform: "translate(-87.26 -96.883)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12170",
    "data-name": "Path 12170",
    d: "M110.913,95.119l2.266,3.915-1.166.676-3.433-5.933,1.166-.676,4.559,2.59-2.266-3.915,1.166-.676,3.433,5.933-1.166.676Z",
    transform: "translate(-102.425 -80.929)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12171",
    "data-name": "Path 12171",
    d: "M146.253,84.291l-2.015-5.125-1.594.626-.494-1.256,4.443-1.747.494,1.256-1.594.626,2.015,5.125-1.253.494Z",
    transform: "translate(-126.303 -70.75)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12172",
    "data-name": "Path 12172",
    d: "M179.918,73.128l.358,1.3-3.612,1-1.825-6.606,3.5-.967.358,1.3-2.2.609.329,1.189,1.871-.517.358,1.3-1.871.517.419,1.519,2.313-.638Z",
    transform: "translate(-149.646 -64.391)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12173",
    "data-name": "Path 12173",
    d: "M208.335,69.2l-1.328.237L205.8,62.689l1.732-.309a2.409,2.409,0,0,1,2.9,1.767,2.163,2.163,0,0,1-.918,2.136L211.69,68.1l-1.019.855-2.414-2.134-.338.061.416,2.315Zm-.248-3.716c.563-.1,1.1-.534,1-1.094s-.563-.817-1.317-.681l-.4.072.318,1.776Z",
    transform: "translate(-171.7 -60.468)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12174",
    "data-name": "Path 12174",
    d: "M241.515,59.365l.393,4.507-1.343.115-.595-6.828,1.342-.115,3.031,4.279-.393-4.507,1.342-.115.595,6.828-1.342.115-3.031-4.276Z",
    transform: "translate(-196.041 -56.46)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12175",
    "data-name": "Path 12175",
    d: "M278.256,61.477l-.468,1.418-1.348-.309L278.9,55.87h1.1l2.457,6.715-1.348.309-.456-1.418h-2.388Zm.436-1.348H280.2l-.754-2.307Z",
    transform: "translate(-222.02 -55.87)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12176",
    "data-name": "Path 12176",
    d: "M311.889,63.4l.41-5.491-1.709-.127.1-1.345,4.761.355-.1,1.345-1.709-.127-.41,5.491-1.345-.1Z",
    transform: "translate(-246.344 -56.275)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12177",
    "data-name": "Path 12177",
    d: "M343.637,66.861l-1.357-.2.987-6.782,1.357.2-.987,6.782Z",
    transform: "translate(-268.911 -58.722)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12178",
    "data-name": "Path 12178",
    d: "M372.131,69.492c-.41,1.758-1.874,3.26-3.629,2.85s-2.408-2.4-2-4.16,1.871-3.26,3.629-2.85S372.538,67.734,372.131,69.492ZM368.8,71.054c1.034.24,1.735-.756,1.995-1.871s.069-2.318-.964-2.558-1.735.756-2,1.871S367.766,70.815,368.8,71.054Z",
    transform: "translate(-286.09 -62.552)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12179",
    "data-name": "Path 12179",
    d: "M402.276,76.46l-1.539,4.256-1.267-.459,2.33-6.447,1.267.459.956,5.156,1.539-4.253,1.267.459-2.33,6.447-1.267-.459-.956-5.156Z",
    transform: "translate(-309.722 -68.631)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12180",
    "data-name": "Path 12180",
    d: "M433.565,96.408l-1.086,1.022-1.039-.912L436.8,91.78l.964.523-1.039,7.076-1.331-.37.274-1.464-2.1-1.138Zm1.022-.979,1.325.719.436-2.388Z",
    transform: "translate(-332.462 -81.412)",
    fill: "#004896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12181",
    "data-name": "Path 12181",
    d: "M465.709,115.365l-.852,1.045-2.818-2.292,4.325-5.318,1.045.849-3.473,4.273,1.773,1.441Z",
    transform: "translate(-354.227 -93.519)",
    fill: "#004896"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3432",
    "data-name": "Group 3432",
    transform: "translate(31.289 37.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430",
    transform: "translate(0 47.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12182",
    "data-name": "Path 12182",
    d: "M52.438,220.687l-1.487.13-.251-1.36,7.14-.407.436,1.008-5.194,4.917-.817-1.114,1.12-.982Zm1.409-.136.6,1.386,1.819-1.608Z",
    transform: "translate(-50.7 -219.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12183",
    "data-name": "Path 12183",
    d: "M77.793,244.176l-1.3.009a1.629,1.629,0,0,0-.448-1.472c-.69-.794-1.882-.3-2.673.39s-1.446,1.8-.754,2.6a1.627,1.627,0,0,0,1.4.647l-.188,1.282a2.759,2.759,0,0,1-2.209-1.06c-1.169-1.345-.491-3.329.855-4.5s3.441-1.527,4.573-.225a2.755,2.755,0,0,1,.745,2.336Z",
    transform: "translate(-65.156 -234.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12184",
    "data-name": "Path 12184",
    d: "M99.824,262.589l-1.265.283a1.63,1.63,0,0,0-.751-1.343c-.843-.629-1.9.107-2.532.95s-1.028,2.07-.188,2.7a1.624,1.624,0,0,0,1.5.335l.09,1.293a2.761,2.761,0,0,1-2.385-.566c-1.429-1.065-1.187-3.15-.121-4.579s3.04-2.223,4.423-1.192a2.756,2.756,0,0,1,1.224,2.125Z",
    transform: "translate(-81 -248.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12185",
    "data-name": "Path 12185",
    d: "M116.519,278.807l-1.189-.632,3.21-6.054,1.553.826a2.41,2.41,0,0,1,1.2,3.182,2.171,2.171,0,0,1-2.041,1.117l.589,2.769-1.331.043-.583-3.167-.3-.162-1.1,2.079Zm2.1-3.078a1.064,1.064,0,0,0,1.464-.245c.268-.505.061-.99-.618-1.348l-.364-.193-.846,1.594Z",
    transform: "translate(-96.671 -256.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12186",
    "data-name": "Path 12186",
    d: "M145.508,290.389l-.5,1.253-3.482-1.38,2.526-6.372,3.378,1.34-.5,1.253-2.125-.843-.456,1.146,1.8.716-.5,1.253-1.8-.716-.58,1.467,2.229.883Z",
    transform: "translate(-115.386 -265.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12187",
    "data-name": "Path 12187",
    d: "M172.314,296.971a3.308,3.308,0,0,1-3.981,2.532l-2.073-.6,1.911-6.583,2.073.6a3.264,3.264,0,0,1,2.073,4.051Zm-4.386,1.013.78.225A1.957,1.957,0,0,0,171,296.59a1.882,1.882,0,0,0-1.132-2.373l-.78-.225Z",
    transform: "translate(-132.998 -271.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12188",
    "data-name": "Path 12188",
    d: "M198.19,306.97l-1.34-.286,1.426-6.7,1.34.286Z",
    transform: "translate(-154.78 -276.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12189",
    "data-name": "Path 12189",
    d: "M217.365,310.123l.82-5.445-1.695-.254.2-1.334,4.723.71-.2,1.334-1.695-.254-.82,5.445-1.334-.2Z",
    transform: "translate(-168.769 -278.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12190",
    "data-name": "Path 12190",
    d: "M239.653,312.595l-.586,1.371-1.317-.422,3.017-6.484,1.094.092,1.879,6.9-1.368.193-.335-1.449-2.379-.2Zm.546-1.308,1.5.127-.557-2.365-.947,2.235Z",
    transform: "translate(-183.911 -281.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12191",
    "data-name": "Path 12191",
    d: "M268.172,315.254l.13-5.506-1.712-.04.032-1.348,4.772.113-.032,1.348-1.712-.04-.13,5.506Z",
    transform: "translate(-204.448 -282.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12192",
    "data-name": "Path 12192",
    d: "M295.915,315.291l-1.368.04-.2-6.851,1.371-.04.2,6.851Z",
    transform: "translate(-224.213 -282.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12193",
    "data-name": "Path 12193",
    d: "M317.644,309.8c.159,1.8-.765,3.681-2.561,3.84s-3.037-1.53-3.2-3.329.762-3.681,2.561-3.84S317.485,308,317.644,309.8Zm-2.679,2.52c1.06-.1,1.415-1.262,1.314-2.4s-.655-2.223-1.715-2.131-1.415,1.262-1.314,2.4S313.9,312.416,314.964,312.324Z",
    transform: "translate(-236.696 -281.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12194",
    "data-name": "Path 12194",
    d: "M343.628,304.635l.759,4.461-1.328.225-1.149-6.756,1.328-.225,3.372,4.016-.759-4.461,1.328-.225,1.149,6.756-1.328.225Z",
    transform: "translate(-258.092 -277.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12195",
    "data-name": "Path 12195",
    d: "M391.044,298.628,389,292.086l3.248-1.016.4,1.288-1.963.612.4,1.288,1.854-.58.4,1.288-1.854.58.837,2.682-1.288.4Z",
    transform: "translate(-291.623 -270.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12196",
    "data-name": "Path 12196",
    d: "M418.991,284.983c.7,1.66.407,3.736-1.253,4.44s-3.361-.523-4.068-2.183-.407-3.736,1.253-4.44S418.284,283.323,418.991,284.983Zm-1.773,3.222c.979-.416.956-1.634.511-2.685s-1.308-1.914-2.287-1.5-.956,1.634-.511,2.685S416.243,288.62,417.218,288.2Z",
    transform: "translate(-308.942 -264.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12197",
    "data-name": "Path 12197",
    d: "M442.568,277.039l-1.161.687-3.488-5.9,1.516-.895a2.409,2.409,0,0,1,3.337.641,2.168,2.168,0,0,1-.113,2.324l2.668.944L444.673,276l-3.005-1.155-.294.173,1.2,2.027Zm-1.53-3.4a1.063,1.063,0,0,0,.554-1.374c-.292-.491-.814-.569-1.472-.179l-.355.211.918,1.553Z",
    transform: "translate(-326.516 -255.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12198",
    "data-name": "Path 12198",
    d: "M466.878,251.873a2.694,2.694,0,1,1-4.039,3.5l-2.619-3.02,1.019-.883,2.29,2.642c.814.941,1.68,1.432,2.431.78s.387-1.576-.427-2.518l-2.289-2.642,1.019-.883,2.619,3.02Z",
    transform: "translate(-342.377 -240.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12199",
    "data-name": "Path 12199",
    d: "M485.608,228.26l3.678,3-.872,1.045-5.084-4.663.647-1.051,4.92,1.423-3.482-3.756.647-1.051,6.45,2.445-.543,1.25-4.336-1.934,3.219,3.528-.647,1.051-4.6-1.291Z",
    transform: "translate(-358.815 -222.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431",
    transform: "translate(9.952 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12200",
    "data-name": "Path 12200",
    d: "M90.679,116.637l-1.039.892-4.469-5.2,1.039-.892Z",
    transform: "translate(-85.17 -94.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12201",
    "data-name": "Path 12201",
    d: "M108.813,93.019l2.266,3.915-1.166.676-3.433-5.933L107.646,91l4.559,2.59-2.266-3.915L111.105,89l3.433,5.933-1.166.676Z",
    transform: "translate(-100.328 -78.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12202",
    "data-name": "Path 12202",
    d: "M144.163,82.191l-2.015-5.125-1.594.626-.494-1.256L144.5,74.69,145,75.946l-1.594.627,2.015,5.125-1.253.494Z",
    transform: "translate(-124.213 -68.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12203",
    "data-name": "Path 12203",
    d: "M177.818,71.028l.358,1.3-3.612,1-1.825-6.606,3.5-.967.358,1.3-2.2.609.329,1.189,1.871-.517.358,1.3-1.871.517.419,1.519,2.313-.638Z",
    transform: "translate(-147.549 -62.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12204",
    "data-name": "Path 12204",
    d: "M206.245,67.109l-1.328.237L203.71,60.6l1.732-.309a2.409,2.409,0,0,1,2.9,1.767,2.163,2.163,0,0,1-.918,2.136l2.171,1.816-1.019.855-2.414-2.134-.338.061.416,2.315ZM206,63.39c.563-.1,1.1-.534,1-1.094s-.563-.817-1.317-.681l-.4.072.318,1.776Z",
    transform: "translate(-169.61 -58.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12205",
    "data-name": "Path 12205",
    d: "M239.415,57.265l.393,4.507-1.343.115-.595-6.828,1.342-.115,3.031,4.279-.393-4.507,1.343-.115.595,6.828-1.342.115-3.031-4.276Z",
    transform: "translate(-193.944 -54.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12206",
    "data-name": "Path 12206",
    d: "M276.166,59.377l-.468,1.418-1.348-.309,2.457-6.715h1.1l2.457,6.715-1.348.309-.456-1.418h-2.388Zm.433-1.348h1.507l-.754-2.307Z",
    transform: "translate(-219.93 -53.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12207",
    "data-name": "Path 12207",
    d: "M309.789,61.3l.41-5.491-1.709-.127.1-1.345,4.761.355-.1,1.345-1.709-.127-.41,5.491-1.345-.1Z",
    transform: "translate(-244.247 -54.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12208",
    "data-name": "Path 12208",
    d: "M341.537,64.761l-1.357-.2.987-6.782,1.357.2-.987,6.782Z",
    transform: "translate(-266.814 -56.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12209",
    "data-name": "Path 12209",
    d: "M370.031,67.4c-.41,1.758-1.871,3.26-3.629,2.85s-2.408-2.4-2-4.16,1.874-3.26,3.629-2.85S370.438,65.644,370.031,67.4ZM366.7,68.961c1.034.24,1.735-.756,1.995-1.871s.069-2.318-.964-2.558-1.735.756-1.995,1.871S365.669,68.722,366.7,68.961Z",
    transform: "translate(-283.993 -60.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12210",
    "data-name": "Path 12210",
    d: "M400.186,74.36l-1.539,4.256-1.267-.459,2.33-6.447,1.267.459.956,5.156,1.539-4.253,1.267.459-2.33,6.447-1.267-.459-.956-5.156Z",
    transform: "translate(-307.632 -66.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12211",
    "data-name": "Path 12211",
    d: "M431.465,94.308l-1.086,1.022-1.039-.912L434.7,89.68l.964.523-1.039,7.076-1.331-.37.274-1.464-2.1-1.138Zm1.025-.979,1.325.719.436-2.388Z",
    transform: "translate(-330.365 -79.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12212",
    "data-name": "Path 12212",
    d: "M463.61,113.275l-.852,1.045-2.818-2.292,4.325-5.318,1.045.849-3.473,4.273,1.773,1.441Z",
    transform: "translate(-352.13 -91.426)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3438",
    "data-name": "Group 3438",
    transform: "translate(57.755 60.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3436",
    "data-name": "Group 3436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3433",
    "data-name": "Group 3433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12213",
    "data-name": "Path 12213",
    d: "M154.6,170.008H145.25V137.32H154.6Z",
    transform: "translate(-144.623 -136.696)",
    fill: "#34328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12214",
    "data-name": "Path 12214",
    d: "M153.681,169.1h-10.6V135.16h10.6Zm-9.348-1.25h8.1V136.413h-8.1Z",
    transform: "translate(-143.08 -135.16)",
    fill: "#007aba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3434",
    "data-name": "Group 3434",
    transform: "translate(15.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12215",
    "data-name": "Path 12215",
    d: "M212.409,164.069l-3.2,6.756-9.193-1.472,16.754-32.033h7.48l16.751,32.033-9.193,1.472-3.115-6.756H212.411Zm2.962-6.427h10.287l-5.142-11.006Z",
    transform: "translate(-199.064 -136.696)",
    fill: "#34328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12216",
    "data-name": "Path 12216",
    d: "M229.086,169.981l-3.147-6.822H210.453l-3.225,6.822L196.71,168.3l17.331-33.138h8.24L239.61,168.3l-10.521,1.683Zm-30.459-2.645,7.87,1.259,3.164-6.689h17.083l3.086,6.689,7.867-1.259-16.171-30.924h-6.721l-16.174,30.924Zm25.661-10.6H212.035l6.129-13.11,6.126,13.11ZM214,155.48h8.318l-4.157-8.9Z",
    transform: "translate(-196.71 -135.16)",
    fill: "#007aba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3435",
    "data-name": "Group 3435",
    transform: "translate(62.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12217",
    "data-name": "Path 12217",
    d: "M360.86,170.008V137.32h23.215v6.43H370.053v6.427H383.3v6.43H370.053v13.4Z",
    transform: "translate(-360.233 -136.696)",
    fill: "#34328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12218",
    "data-name": "Path 12218",
    d: "M369.136,169.1H358.69V135.16h24.465v7.68H369.133v5.174h13.243v7.68H369.133v13.4Zm-9.193-1.25h7.94v-13.4h13.243v-5.177H367.883v-7.68h14.023v-5.177H359.943Z",
    transform: "translate(-358.69 -135.16)",
    fill: "#007aba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3437",
    "data-name": "Group 3437",
    transform: "translate(0.627 0.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12219",
    "data-name": "Path 12219",
    d: "M154.6,170.008H145.25V137.32H154.6Z",
    transform: "translate(-145.25 -137.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12220",
    "data-name": "Path 12220",
    d: "M212.409,164.069l-3.2,6.756-9.193-1.472,16.754-32.033h7.48l16.751,32.033-9.193,1.472-3.115-6.756H212.411Zm2.962-6.427h10.287l-5.142-11.006Z",
    transform: "translate(-184.207 -137.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12221",
    "data-name": "Path 12221",
    d: "M360.86,170.008V137.32h23.215v6.43H370.053v6.427H383.3v6.43H370.053v13.4Z",
    transform: "translate(-298.611 -137.32)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaf);
export default __webpack_public_path__ + "static/media/IAF.96a160cea1b15dc63d89e2c1cd9a9953.svg";
export { ForwardRef as ReactComponent };